(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const drawer = $('[data-hg-cart-drawer]');
  const toast = $('[data-hg-toast]');
  const offerVariantId = Number(drawer?.dataset.hgOfferVariantId || 0);
  const offerComparePrice = Number(drawer?.dataset.hgOfferCompare || 0);
  const threePackVariantId = Number(drawer?.dataset.hgThreeVariantId || 0);
  const threePackComparePrice = Number(drawer?.dataset.hgThreeCompare || 0);
  const threePackImage = 'https://cdn.shopify.com/s/files/1/0671/4415/5223/files/himagold-3x2-regalo_85791de2-a22d-4c5a-ac01-dc1c25c73086.png?v=1787900909';
  const currency = 'CLP';
  const moneyFormatter = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  const money = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);
  let drawerTrigger = null;
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  })[char]);

  const notify = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(notify.timer);
    notify.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  const updateCartIndicators = (count) => {
    $$('[data-hg-cart-count]').forEach((node) => { node.textContent = count; });
    $$('[data-hg-cart-open]').forEach((button) => {
      button.setAttribute('aria-label', `Abrir carrito, ${count} ${count === 1 ? 'artículo' : 'artículos'}`);
    });
  };

  const renderCart = (cart) => {
    const lines = $('[data-hg-cart-lines]');
    const foot = $('[data-hg-cart-foot]');
    updateCartIndicators(cart.item_count);
    if (!lines || !foot) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="hg-drawer-empty"><strong>Tu carrito está vacío.</strong><p class="hg-muted">Conoce el pack 2×1 con envío gratis a todo Chile.</p><a class="hg-button hg-button--dark hg-button--full" href="/#oferta">Ver oferta 2×1</a></div>';
      foot.hidden = true;
      return;
    }
    lines.innerHTML = cart.items.map((item) => {
      const isTwoPack = Number(item.variant_id) === offerVariantId || String(item.variant_title || '').trim().toLocaleLowerCase('es') === '2 frascos';
      const isThreePack = Number(item.variant_id) === threePackVariantId || String(item.variant_title || '').trim().toLocaleLowerCase('es') === '3 frascos';
      const variantLabel = isTwoPack ? 'Pack 2 frascos · 2×1' : (isThreePack ? 'Pack 3 frascos · 3×2' : (item.variant_title || ''));
      const quantityLabel = isTwoPack || isThreePack ? 'Cantidad de packs' : 'Cantidad';
      const compareUnitPrice = isTwoPack ? offerComparePrice : (isThreePack ? threePackComparePrice : 0);
      const compareLinePrice = compareUnitPrice * item.quantity;
      const savings = Math.max(0, compareLinePrice - Number(item.final_line_price || 0));
      const offerMeta = compareLinePrice > Number(item.final_line_price || 0)
        ? `<small class="hg-cart-line__offer"><s>Antes ${money(compareLinePrice)}</s> · Ahorras ${money(savings)}</small>`
        : '';
      const sourceImage = isThreePack ? threePackImage : item.image;
      const imageUrl = sourceImage ? `${escapeHTML(sourceImage)}${sourceImage.includes('?') ? '&' : '?'}width=160` : '';
      return `
        <div class="hg-cart-line">
          ${imageUrl ? `<img src="${imageUrl}" alt="${escapeHTML(item.product_title)}" width="72" height="72" loading="lazy" decoding="async">` : '<span></span>'}
          <div><strong>${escapeHTML(item.product_title)}</strong><small>${escapeHTML(variantLabel)} · ${quantityLabel} ${item.quantity}</small><small>${money(item.final_line_price)}</small>${offerMeta}</div>
          <button class="hg-cart-remove" type="button" data-hg-remove="${escapeHTML(item.key)}">Quitar</button>
        </div>`;
    }).join('');
    $('[data-hg-cart-total]').textContent = money(cart.total_price);
    foot.hidden = false;
    $$('[data-hg-remove]', lines).forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id: button.dataset.hgRemove, quantity: 0})
        });
        if (!response.ok) throw new Error('cart-change');
        renderCart(await response.json());
        notify('Producto eliminado del carrito.');
      } catch (error) {
        button.disabled = false;
        notify('No pudimos quitar el producto. Intenta nuevamente.');
      }
    }));
  };

  const loadCart = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers: {'Accept': 'application/json'}});
      const cart = await response.json();
      renderCart(cart);
      return cart;
    } catch (error) {
      notify('No pudimos actualizar el carrito. Intenta nuevamente.');
      return null;
    }
  };

  const setDrawer = (open, refresh = true) => {
    if (!drawer) return;
    if (open) drawerTrigger = document.activeElement;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('hg-lock', open);
    $$('[data-hg-cart-open]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
    if (open) {
      if (refresh) loadCart();
      window.requestAnimationFrame(() => $('[data-hg-cart-close]', drawer)?.focus());
    } else if (drawerTrigger instanceof HTMLElement) {
      drawerTrigger.focus();
    }
  };

  $$('[data-hg-cart-open]').forEach((button) => button.addEventListener('click', () => setDrawer(true)));
  $$('[data-hg-cart-close]').forEach((button) => button.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', (event) => {
    if (!drawer?.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      setDrawer(false);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer)
      .filter((node) => node.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  $$('[data-hg-product-form]').forEach((form) => {
    const productScope = form.closest('[data-hg-product]');
    const price = productScope ? $('[data-hg-price]', productScope) : null;
    const compareWrap = productScope ? $('[data-hg-compare-wrap]', productScope) : null;
    const compare = productScope ? $('[data-hg-compare]', productScope) : null;
    const priceCaption = productScope ? $('[data-hg-price-caption]', productScope) : null;
    const packCount = productScope ? $('[data-hg-pack-count]', productScope) : null;
    const gummiesTotal = productScope ? $('[data-hg-gummies-total]', productScope) : null;
    const stockStatuses = productScope ? $$('[data-hg-stock-status]', productScope) : [];
    const stickyPrice = productScope ? $('[data-hg-sticky-price]', productScope) : null;
    const stickyLabel = productScope ? $('[data-hg-sticky-label]', productScope) : null;
    const submitLabel = productScope ? $('[data-hg-submit-label]', productScope) : null;
    const gallery = productScope ? $('[data-hg-gallery]', productScope) : null;
    const updateVariant = () => {
      const selected = $('input[name="id"]:checked', form) || $('input[name="id"]', form);
      if (!selected) return;
      const formatted = selected.dataset.priceFormatted || money(selected.dataset.price);
      if (price) price.textContent = formatted;
      if (stickyPrice) stickyPrice.textContent = formatted;
      if (compareWrap) compareWrap.hidden = !selected.dataset.compareFormatted;
      if (compare) compare.textContent = selected.dataset.compareFormatted || '';
      if (priceCaption) priceCaption.textContent = selected.dataset.priceCaption || '';
      if (packCount) packCount.textContent = `${selected.dataset.packCount || ''} FRASCOS`;
      if (gummiesTotal) gummiesTotal.textContent = selected.dataset.gummiesTotal || '';
      stockStatuses.forEach((stockStatus) => { stockStatus.textContent = selected.dataset.stockLabel || 'Stock disponible'; });
      if (stickyLabel) stickyLabel.textContent = selected.dataset.packLabel || 'Pack HIMAGOLD';
      if (submitLabel) submitLabel.textContent = selected.dataset.buttonLabel || 'Comprar pack';
      $$('.hg-pack', form).forEach((pack) => pack.classList.toggle('is-selected', pack.contains(selected)));
      if (gallery) gallery.dispatchEvent(new CustomEvent('hg:set-pack', {detail: {pack: selected.dataset.galleryPack || '2'}}));
    };
    $$('input[name="id"]', form).forEach((input) => input.addEventListener('change', updateVariant));
    updateVariant();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = $('button[type="submit"]', form);
      const selected = $('input[name="id"]:checked', form) || $('input[name="id"]', form);
      if (!selected) return;
      const original = button?.textContent;
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Agregando…'; }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: Number(selected.value), quantity: 1}]})
        });
        if (!response.ok) throw new Error('cart');
        await loadCart();
        setDrawer(true, false);
        notify(`${selected.dataset.packLabel || 'Pack HIMAGOLD'} agregado · envío gratis a todo Chile.`);
      } catch (error) {
        notify('No pudimos agregar el producto. Intenta nuevamente.');
      } finally {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = original; }
      }
    });
  });

  $$('[data-hg-sticky-add]').forEach((button) => button.addEventListener('click', () => {
    $('[data-hg-product] [data-hg-product-form]')?.requestSubmit();
  }));

  $$('[data-hg-quantity]').forEach((quantity) => {
    const input = $('input[type="number"]', quantity);
    const minus = $('[data-hg-quantity-minus]', quantity);
    const plus = $('[data-hg-quantity-plus]', quantity);
    if (!input) return;
    let updateTimer = null;
    let isSubmitting = false;
    const queueUpdate = () => {
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(() => {
        const form = input.form;
        const updateButton = form ? $('button[name="update"]', form) : null;
        if (!form || !updateButton || isSubmitting) return;
        isSubmitting = true;
        quantity.setAttribute('aria-busy', 'true');
        if (minus) minus.disabled = true;
        if (plus) plus.disabled = true;
        input.readOnly = true;
        updateButton.textContent = 'Actualizando…';
        form.requestSubmit(updateButton);
      }, 250);
    };
    const change = (amount) => {
      const current = Number.parseInt(input.value, 10) || 0;
      const next = Math.max(0, current + amount);
      if (next === current) return;
      input.value = next;
      queueUpdate();
    };
    minus?.addEventListener('click', () => change(-1));
    plus?.addEventListener('click', () => change(1));
    input.addEventListener('change', () => {
      const parsed = Number.parseInt(input.value, 10);
      input.value = Math.max(0, Number.isFinite(parsed) ? parsed : 0);
      queueUpdate();
    });
  });

  const initGalleries = (root = document) => {
    $$('[data-hg-gallery]', root).forEach((gallery) => {
      if (gallery.dataset.hgGalleryReady === 'true') return;
      const slides = $$('[data-hg-gallery-slide]', gallery);
      const dots = $$('[data-hg-gallery-dot]', gallery);
      const stage = $('[data-hg-gallery-stage]', gallery);
      const counter = $('[data-hg-gallery-counter]', gallery);
      if (slides.length < 2 || !stage) return;

      let activePack = gallery.dataset.hgActivePack || '2';
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let pointerStartX = null;
      const visibleIndexes = () => slides.reduce((indexes, slide, index) => {
        const slidePack = slide.dataset.hgGalleryPack || 'shared';
        if (slidePack === 'shared' || slidePack === activePack) indexes.push(index);
        return indexes;
      }, []);
      const showSlide = (nextPosition) => {
        const available = visibleIndexes();
        if (!available.length) return;
        const normalizedPosition = (nextPosition + available.length) % available.length;
        activeIndex = available[normalizedPosition];
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          const visible = available.includes(index);
          slide.hidden = !visible;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, index) => {
          const active = index === activeIndex;
          const visiblePosition = available.indexOf(index);
          const visible = visiblePosition !== -1;
          dot.hidden = !visible;
          dot.disabled = !visible;
          dot.classList.toggle('is-active', active);
          if (visible) dot.setAttribute('aria-label', `Ver foto ${visiblePosition + 1} de ${available.length} del pack ${activePack === '3' ? '3×2' : '2×1'}`);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = `${normalizedPosition + 1} / ${available.length}`;
        gallery.setAttribute('aria-label', `Galería del pack HIMAGOLD ${activePack === '3' ? '3×2' : '2×1'}`);
      };
      const showRelative = (amount) => {
        const available = visibleIndexes();
        const activePosition = Math.max(0, available.indexOf(activeIndex));
        showSlide(activePosition + amount);
      };
      const setPack = (pack) => {
        activePack = String(pack) === '3' ? '3' : '2';
        gallery.dataset.hgActivePack = activePack;
        showSlide(0);
      };

      gallery.addEventListener('hg:set-pack', (event) => setPack(event.detail?.pack));
      $('[data-hg-gallery-prev]', gallery)?.addEventListener('click', () => showRelative(-1));
      $('[data-hg-gallery-next]', gallery)?.addEventListener('click', () => showRelative(1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        const position = visibleIndexes().indexOf(index);
        if (position !== -1) showSlide(position);
      }));
      stage.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showRelative(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showRelative(1); }
      });
      stage.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary) return;
        pointerStartX = event.clientX;
      });
      stage.addEventListener('pointerup', (event) => {
        if (pointerStartX === null || !event.isPrimary) return;
        const delta = event.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(delta) < 48) return;
        showRelative(delta < 0 ? 1 : -1);
      });
      stage.addEventListener('pointercancel', () => { pointerStartX = null; });
      setPack(activePack);
      gallery.dataset.hgGalleryReady = 'true';
    });
  };

  initGalleries();
  document.addEventListener('shopify:section:load', (event) => initGalleries(event.target));

  const initReviewToggles = (root = document) => {
    $$('[data-hg-reviews-toggle]', root).forEach((button) => {
      if (button.dataset.hgReviewsReady === 'true') return;
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;
      const cards = $$('[data-hg-review-card]', target);
      const status = target.parentElement?.querySelector('[data-hg-reviews-status]');
      const step = Math.max(1, Number(button.dataset.hgReviewStep || 3));
      let visibleCount = Math.min(step, cards.length);
      const render = () => {
        cards.forEach((card, index) => { card.hidden = index >= visibleCount; });
        const fullyExpanded = visibleCount >= cards.length;
        button.hidden = cards.length <= step;
        button.setAttribute('aria-expanded', String(visibleCount > step));
        const label = $('[data-hg-reviews-toggle-label]', button);
        if (label) label.textContent = fullyExpanded ? 'Ver menos reseñas' : 'Ver más reseñas';
        if (status) status.textContent = `Mostrando ${visibleCount} de ${cards.length} reseñas`;
      };
      button.addEventListener('click', () => {
        visibleCount = visibleCount >= cards.length ? Math.min(step, cards.length) : Math.min(cards.length, visibleCount + step);
        render();
        if (visibleCount === step) target.scrollIntoView({behavior: 'smooth', block: 'start'});
      });
      render();
      button.dataset.hgReviewsReady = 'true';
    });
  };

  initReviewToggles();
  document.addEventListener('shopify:section:load', (event) => initReviewToggles(event.target));

  const initCountdowns = (root = document) => {
    $$('[data-hg-countdown]', root).forEach((node) => {
      if (node.dataset.hgCountdownReady === 'true') return;
      const firstDeadline = Date.parse(node.dataset.hgCountdown || '');
      const cycleHours = Number(node.dataset.hgCountdownCycleHours || 0);
      const cycleDuration = Number.isFinite(cycleHours) && cycleHours > 0 ? cycleHours * 60 * 60 * 1000 : 0;
      if (!Number.isFinite(firstDeadline)) {
        node.textContent = 'Oferta activa';
        return;
      }
      const nextDeadline = (now) => {
        if (!cycleDuration || now < firstDeadline) return firstDeadline;
        const completedCycles = Math.floor((now - firstDeadline) / cycleDuration) + 1;
        return firstDeadline + (completedCycles * cycleDuration);
      };
      const render = () => {
        const now = Date.now();
        const remaining = Math.max(0, nextDeadline(now) - now);
        const totalSeconds = Math.ceil(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        node.textContent = `${days ? `${days}d ` : ''}${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      };
      const timer = window.setInterval(render, 1000);
      node.dataset.hgCountdownReady = 'true';
      render();
    });
  };

  initCountdowns();
  document.addEventListener('shopify:section:load', (event) => initCountdowns(event.target));

  const sticky = $('[data-hg-sticky]');
  const purchaseButton = $('.hg-product-form .hg-button');
  const footer = $('.hg-footer');
  let purchasePassed = false;
  let footerVisible = false;
  const setStickyVisibility = (isVisible) => {
    if (!sticky) return;
    sticky.classList.toggle('is-visible', isVisible);
    sticky.setAttribute('aria-hidden', String(!isVisible));
  };
  const syncStickyVisibility = () => setStickyVisibility(purchasePassed && !footerVisible);
  if (sticky && purchaseButton && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(([entry]) => {
      purchasePassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      syncStickyVisibility();
    }, {threshold: 0});
    stickyObserver.observe(purchaseButton);
    if (footer) {
      const footerObserver = new IntersectionObserver(([entry]) => {
        footerVisible = entry.isIntersecting;
        syncStickyVisibility();
      }, {threshold: 0});
      footerObserver.observe(footer);
    }
  } else {
    const offer = $('[data-hg-product]');
    const onScroll = () => {
      purchasePassed = Boolean(offer && window.scrollY > offer.offsetTop + 320);
      footerVisible = Boolean(footer && footer.getBoundingClientRect().top < window.innerHeight);
      syncStickyVisibility();
    };
    window.addEventListener('scroll', onScroll, {passive: true});
    onScroll();
  }
})();
